import { CLEAR_STORES, UPDATE_STORES } from './store.action';
import { Store } from '@whiz-cart/node-shared/models/store';

type StoreReducerParam =
    | {
          type: typeof UPDATE_STORES;
          payload: Record<string, Store>;
      }
    | {
          type: typeof CLEAR_STORES;
          payload: undefined;
      };

export default (state: { stores: Record<string, Store>; isLoaded?: boolean } = { stores: {} }, { type, payload }: StoreReducerParam) => {
    switch (type) {
        case UPDATE_STORES:
        case CLEAR_STORES:
            return { ...state, stores: payload || {}, isLoaded: type === UPDATE_STORES };
        default:
            return state;
    }
};
